/**
 * Maximum regex pattern length. Caps extremely long patterns but does not
 * prevent all pathological backtracking from shorter expressions.
 */
const MAX_REGEX_LENGTH = 1000;

/**
 * Checks whether a string is a valid, safely-sized regex pattern.
 *
 * Shared between the UI layer (ColumnFilterPopover) and the search engine
 * (LogSearchEngine) so that validity checks stay in sync.
 */
export function isValidRegex(pattern: string): boolean {
  if (pattern.length > MAX_REGEX_LENGTH) {
    return false;
  }
  try {
    new RegExp(pattern);
    return true;
  } catch {
    return false;
  }
}
